import { TAGS, FORWARD_RECEIVER } from './GeneralEventAnalytics';

// enums
export const CHAT_SOURCES = {
  chatListPage: 'Chat List Page',
  pushNotif: 'Push Notification',
  userProfile: 'User Profile',
  sharePost: 'Share Post (Stream)',
};

export const GROUP_CHAT_SOURCES = {
  chatListPage: 'Chat List Page',
  pushNotif: 'Push Notification',
  userProfile: 'User Profile',
  chatSearch: 'Chat Search',
  // Group Chat Room Viewed when create new group success, redirect to group chat room viewed
  createNewGroup: 'Create New Group',
  chatRoom: 'Chat Room',
  groupInformation: 'Group Information',
};

export const GROUP_CHAT_ACTIONS = {
  createNewGroup: 'Group Chat Create New Group',
  searchContactFilled: 'Group Chat Search Contact Filled',
  createNewGroupNextFilled: 'Group Chat Create New Group Next Clicked',
  addGroupPhotoSelected: 'Group Chat Add Group Photo Selected',
  groupNameFilled: 'Group Chat Group Name Filled',
  groupDescriptionFilled: 'Group Chat Description Filled',
  createClicked: 'Group Chat Create Clicked',
  uploadImageSelected: 'Group Chat Upload Image Selected',
  removePhotoSelected: 'Group Chat Remove Photo Selected',
  requestGroupChatAcceptSelected:
    'Group Chat Request Group Chat Accept Selected',
  requestGroupChatLeaveSelected: 'Group Chat Request Group Chat Leave Selected',
};

export const GROUP_CHAT_INFO_SETTINGS_ACTIONS = {
  moreSelected: 'Group Chat More Selected',
  groupInfoSelected: 'Group Chat Group Info Selected',
  groupChatAddAttachment: 'Group Chat Add Attachment',
  groupChatAttachmentSelected: 'Group Chat Attachment Selected',
  muteNotificationsSelected: 'Group Chat Mute Notifications Selected',
  unMuteNotificationSelected: 'Group Chat Unmute Notifications Selected',
  selectMessagesSelected: 'Group Chat Select Messages Selected',
  leaveGroupSelected: 'Group Chat Leave Group Selected',
  sendMessage: 'Group Chat Send',
  editGroupInfoSelected: 'Group Chat Edit Group Info Selected',
  giveATipSelected: 'Group Chat Give a Tip Selected',
  addMemberSelected: 'Group Chat Add Member Selected',
  inviteViaLinkSelected: 'Group Chat Invite via Link Selected',
  userAvatarMemberSelected: 'Group Chat User Avatar Member Selected',
  chatGroupPhotoSelected: 'Group Chat Change Group Photo Selected',
  editGroupNameSelected: 'Group Chat Edit Group Name Selected',
  editDescriptionSelected: 'Group Chat Edit Description Selected',
  viewPhotoSelected: 'Group Chat View Photo Selected',
  uploadPhotoSelected: 'Group Chat Upload Photo Selected',
  removePhotoSelected: 'Group Chat Remove Photo Selected',
  confirmationRemovePhotoClicked:
    'Group Chat Confirmation Remove Photo Clicked',
  confirmationCancelRemovePhotoClicked:
    'Group Chat Confirmation Cancel Remove Photo Clicked',
  addMemberDoneSubmitted: 'Group Chat Done Submitted',
  textLinkCopied: 'Group Chat Text Link Copied',
  sendLinkViaStockbitSelected: 'Group Chat Send Link via Stockbit Selected',
  copyLinkSelected: 'Group Chat Copy Link Selected',
  shareLinkSelected: 'Group Chat Share Link Selected',
  resetLinkSelected: 'Group Chat Reset Link Selected',
  userSendInvitationSelected: 'Group Chat User Send Invitation Selected',
  groupInvitationSendSubmitted: 'Group Chat Send Submitted',
  resetLinkClicked: 'Group Chat Reset Link Clicked',
  cancelResetLinkClicked: 'Group Chat Cancel Reset Link Clicked',
  deleteTheGroupForAllMembersClicked:
    'Group Chat Delete the group for all members Clicked',
  leaveGroupClicked: 'Group Chat Leave Clicked',
  cancelLeaveGroupClicked: 'Group Chat Cancel Leave Clicked',
  chooseAdminClicked: 'Group Chat Choose Admin Clicked',
  cancelChooseAdminClicked: 'Group Chat Cancel Choose Admin Clicked',
  newAdminSelected: 'Group Chat New Admin Selected',
  setNewAdminAndLeaveGroupSubmitted:
    'Group Chat Set New Admin and Leave Group Submitted',
  viewUserProfileSelected: 'Group Chat View User Profile Selected',
  chatUserSelected: 'Group Chat Chat User Selected',
  assignAdminSelected: 'Group Chat Assign Admin Selected',
  removeUserFromGroupSelected: 'Group Chat Remove User From Group Selected',
  chooseMemberToGiveATipSelected:
    'Group Chat Choose Member To Give a Tip Selected',
  chooseTip: 'Group Chat Choose Tip',
  tipInputted: 'Group Chat Tip Inputted',
  addMessageTipFilled: 'Group Chat Add Message Tip Filled',
  sendTipSubmitted: 'Group Chat Send Tip Submitted',
  confirmAssignAdminClicked: 'Group Chat Confirm Assign Admin Clicked',
  cancelAssignAdminClicked: 'Group Chat Cancel Assign Admin Clicked',
  removeUserClicked: 'Group Chat Remove User Clicked',
  cancelRemoveUserClicked: 'Group Chat Cancel Remove User Clicked',
  joinGroupInvitationLinkOpened: 'Join Group Invitation Link Opened',
  cancelJoinGroupClicked: 'Cancel Join Group Clicked',
  groupChatMessageOpened: 'Group Chat Message Opened',
  removeAdminClicked: 'Group Chat Admin Role Removed',
  cancelRemoveAdmin: 'Group Chat Cancel Admin Role Removed',
};

export const GROUP_CHAT_MEMBER_TYPE = {
  admin: 'Admin',
  nonAdmin: 'Non Admin',
};

export const GROUP_CHAT_ATTACHMENTS = {
  chooseExistingPicture: 'Choose Existing Picture',
  GIF: 'GIF',
  documents: 'Documents',
  none: 'None',
};

export const GROUP_CHAT_TAGS = { ...TAGS };

export const GROUP_CHAT_FORWARD_RECEIVER = { ...FORWARD_RECEIVER };
